import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { ValidationErrors } from 'ngrx-forms';
import { StringUtils } from '@macs-frontend/features/shared/utils/string';

@Component({
  selector: 'md-form-errors',
  templateUrl: 'form-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['form-errors.component.scss'],
})
export class FormErrorsComponent extends BaseComponent {
  @Input()
  errors: ValidationErrors | null | undefined = null;

  getErrorMessage() {
    if (!this.errors) {
      return null;
    }

    const firstEntry = Object.entries(this.errors)[0];
    if (!firstEntry) {
      return null;
    }

    const [key, value] = firstEntry;

    if (typeof value === 'string') {
      return value;
    }

    if (
      value &&
      typeof value === 'object' &&
      'message' in value &&
      typeof (value as { message?: unknown }).message === 'string'
    ) {
      return (value as { message: string }).message;
    }

    switch (key) {
      case 'email':
        return 'Invalid email';
    }

    return StringUtils.humanizeTextCode(key);
  }
}
